(function () {
  const initSliders = () => {
    document.querySelectorAll('.image-peek-slider').forEach((wrapper) => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';

      const autoplay = wrapper.dataset.autoplay === 'true';
      const continuous = wrapper.dataset.continuous === 'true';
      const speed = parseFloat(wrapper.dataset.speed) * 1000 || 800;
      const delay = parseFloat(wrapper.dataset.delay) * 1000 || 3000;
      const desktopCount = parseInt(wrapper.dataset.spvDesktop, 10) || 2;
      const mobileCount = parseInt(wrapper.dataset.spvMobile, 10) || 1;

      const swiperEl = wrapper.querySelector('.swiper');
      if (!swiperEl) return;

      const wrapperEl = swiperEl.querySelector('.swiper-wrapper');
      const originalSlides = Array.from(swiperEl.querySelectorAll('.swiper-slide'));
      const maxSpv = Math.max(desktopCount, mobileCount);

      if (continuous && autoplay) {
        originalSlides.forEach((slide) => {
          wrapperEl.appendChild(slide.cloneNode(true));
        });

        new Swiper(swiperEl, {
          loop: false,
          slidesPerView: mobileCount,
          spaceBetween: 8,
          allowTouchMove: false,
          breakpoints: {
            990: { slidesPerView: desktopCount },
          },
        });

        // Swiper updates transforms in the first frame; paint (and correct offsetWidth) happens in the second
        requestAnimationFrame(() => requestAnimationFrame(() => {
          const slideW = originalSlides[0]?.getBoundingClientRect().width;
          if (!slideW) return;

          const setWidth = originalSlides.length * (slideW + 8);
          const duration = (originalSlides.length * speed) / 1000;

          wrapperEl.style.setProperty('--marquee-width', `${setWidth}px`);
          wrapperEl.style.setProperty('--marquee-duration', `${duration}s`);
          wrapperEl.classList.add('image-peek-marquee');

          swiperEl.addEventListener('mouseenter', () => {
            wrapperEl.style.animationPlayState = 'paused';
          });
          swiperEl.addEventListener('mouseleave', () => {
            wrapperEl.style.animationPlayState = 'running';
          });
        }));

        wrapper._swiperInstance = null;
        return;
      }

      const minRequired = Math.max(maxSpv * 3, 8);
      let cloneCount = 0;
      while (originalSlides.length + cloneCount < minRequired) {
        const clone = originalSlides[cloneCount % originalSlides.length].cloneNode(true);
        wrapperEl.appendChild(clone);
        cloneCount++;
      }

      const swiper = new Swiper(swiperEl, {
        loop: true,
        loopAdditionalSlides: maxSpv,
        slidesPerView: mobileCount,
        spaceBetween: 8,
        speed: speed,
        cssEase: 'ease-out',
        autoplay: autoplay
          ? { delay: delay, disableOnInteraction: false, pauseOnMouseEnter: true }
          : false,
        breakpoints: {
          990: { slidesPerView: desktopCount },
        },
      });

      wrapper._swiperInstance = swiper;
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initSliders();
    document.addEventListener('shopify:section:load', initSliders);
    document.addEventListener('shopify:section:unload', (event) => {
      const wrapper = event.target.querySelector('.image-peek-slider');
      if (wrapper?._swiperInstance) {
        wrapper._swiperInstance.destroy(true, true);
      }
      const wrapperEl = wrapper?.querySelector('.swiper-wrapper');
      if (wrapperEl) {
        wrapperEl.classList.remove('image-peek-marquee');
      }
      if (wrapper) delete wrapper.dataset.initialized;
    });
  });
})();
